import { render, staticRenderFns } from "./RacerResults.vue?vue&type=template&id=720637e4"
import script from "./RacerResults.vue?vue&type=script&lang=js"
export * from "./RacerResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports